var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#253a7e;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188.61,566.33s55.1,13.56,98.75-20.73,42.28-86,42.28-86-49.39-15.37-94.25,17.33S188.61,566.33,188.61,566.33Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188.43,592.19s9,38.79,44.29,55.25,67.24-.79,67.24-.79-6-35.79-40.73-53.52S188.43,592.19,188.43,592.19Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M271.46,575.4s19.05,21.18,46.85,19.26,41.83-23.78,41.83-23.78-16.17-20.32-44-19.4S271.46,575.4,271.46,575.4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M243.6,441.71s-29.37-48.55-84.49-55.17S68.4,417.46,68.4,417.46s24.06,45.79,78.9,54.39S243.6,441.71,243.6,441.71Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M262,423.55s21.08-33.78,7.75-70.38-48.11-47-48.11-47-21,29.58-9,66.64S262,423.55,262,423.55Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M191.43,376.72s1.5-28.45-19.52-46.76-46.38-12.76-46.38-12.76-2.94,25.8,17.41,44.85S191.43,376.72,191.43,376.72Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142,508.43S93.42,537.8,86.81,592.92s30.91,90.7,30.91,90.7,45.79-24,54.39-78.89S142,508.43,142,508.43Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.81,490S90,468.93,53.43,482.26s-47,48.11-47,48.11,29.58,21,66.64,9S123.81,490,123.81,490Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77,560.6s-28.45-1.51-46.75,19.51S17.46,626.5,17.46,626.5s25.81,2.94,44.86-17.41S77,560.6,77,560.6Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M454.51,398.33h41.38L609.74,589.26H569.18Zm0,190.93V411l41.11,69,1.89,109.26ZM567,398.33h42.73V575.19L568.64,506Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M651.39,589.26V398.33h43.27V589.26Zm50-79.24V463l60.3-64.64h55.71l-87.35,86.54,91.68,104.39H768.48Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M838,398.33h41.38L993.21,589.26H952.65Zm0,190.93V411l41.11,69L881,589.26Zm112.5-190.93h42.73V575.19L952.11,506Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.209bd279852f422f9558e82caa9c1a1a.svg";
export { ForwardRef as ReactComponent };